export const arabicStylesBack = `
.cx-message-text ul,
.cx-message-text p {
  direction: rtl !important;
  text-align: right !important;
}

.cx-webchat .cx-transcript .cx-message-group > .cx-message {
  direction: rtl !important;
  text-align: right !important;
}

.cx-webchat .cx-transcript .cx-message-group>.cx-message.cx-participant:first-child .cx-bubble-arrow,
.cx-webchat .cx-transcript .cx-message-group>.cx-message.cx-participant:first-child .cx-name {
  direction: rtl !important;
  text-align: right !important;
}
.cx-widget.cx-theme-light .cx-message .cx-bubble .cx-message-text {
  direction: rtl !important;
  text-align: right !important;
}

.cx-webchat .cx-transcript .cx-message-group>.cx-message.cx-participant:last-child .cx-time {
  text-align: right !important;
}

.cx-widget.cx-theme-light .cx-message .cx-bubble .cx-message-text ul,
.cx-widget.cx-theme-light .cx-message .cx-bubble .cx-message-text ol
{
  padding-right: 15px !important;
}

.cx-webchat .cx-transcript .cx-message-group > .cx-message .cx-time {
  direction: ltr !important;
}
`;

export const arabicStylesComplete = `
.cx-message-text ul,
.cx-message-text p {
  direction: rtl !important;
  text-align: right !important;
}

.cx-form-inputs {
  direction: rtl !important;
  text-align: right !important;
}

.cx-webchat .cx-form table th {
  padding-right: 0 !important;
  padding-left: 8px !important;
  direction: rtl !important;
  text-align: right !important;
}

.cx-webchat .cx-transcript .cx-message-group > .cx-message {
  direction: rtl !important;
  text-align: right !important;
}

.cx-webchat .cx-transcript .cx-message-group>.cx-message.cx-participant:first-child .cx-bubble-arrow,
.cx-webchat .cx-transcript .cx-message-group>.cx-message.cx-participant:first-child .cx-name {
  direction: rtl !important;
  text-align: right important;
}
.cx-widget.cx-theme-light .cx-message .cx-bubble .cx-message-text {
  direction: rtl !important;
  text-align: right !important;
}

.cx-webchat .cx-transcript .cx-message-group>.cx-message.cx-participant:last-child .cx-time {
  text-align: right !important;
}

.cx-widget.cx-theme-light .cx-message .cx-bubble .cx-message-text ul,
.cx-widget.cx-theme-light .cx-message .cx-bubble .cx-message-text ol
{
  padding-right: 15px !important;
}

.cx-message-input.cx-input.i18n.cx-form-control {
  direction: rtl !important;
  text-align: right !important;
  padding-right: 0px !important;
  padding-left: 50px !important;
}

.cx-webchat .cx-send {
  left: 0 !important;
  transform: translateX(10px) !important;
}

.cx-webchat .cx-transcript .cx-message-group > .cx-message .cx-time {
  direction: ltr !important;
  text-align: right !important;
}
`;
